"use strict";

export function initInScope($scope) {
    if (window.ApplePaySession && ApplePaySession.canMakePayments) {
        $scope.find('.js-apple-pay').removeClass('d-none');
    }
}